export default __webpack_public_path__ + "static/media/wave_yellow.72b4e000.svg";